import React, { PropsWithChildren } from 'react';

import { StandardButton } from '@eika/button';
import { ErrorCard } from '@eika/card';

import { generateDataTrackIdForAction, SideDetail } from '../../utils/piwik-utils';

import './error.scss';

interface ErrorButtonProps {
    sideDetail: SideDetail;
    buttonText: string;
    buttonDataTrackId: string;
    onButtonClick: () => void;
}

interface Props {
    headerText: string;
    errorButtonProps?: ErrorButtonProps;
    bodyText?: string;
    className?: string;
}

export const Error: React.FC<PropsWithChildren<Props>> = ({
    children,
    headerText,
    bodyText,
    errorButtonProps,
    className,
}) => (
    <ErrorCard title={headerText} description={bodyText} className={className}>
        {children}
        {errorButtonProps && (
            <div className="error-button-wrapper">
                <StandardButton
                    type="button"
                    onClick={errorButtonProps.onButtonClick}
                    data-track-id={generateDataTrackIdForAction(
                        errorButtonProps.buttonDataTrackId,
                        errorButtonProps.sideDetail,
                    )}
                >
                    {errorButtonProps.buttonText}
                </StandardButton>
            </div>
        )}
    </ErrorCard>
);
